document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-reserve-purchase-toggle]').forEach((wrap) => {
    const options = wrap.querySelectorAll('[data-reserve-option]');

    options.forEach((option) => {
      const radio = option.querySelector('[data-reserve-radio]');

      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        options.forEach((other) => other.classList.toggle('is-selected', other === option));
      });
    });
  });
});
